(function () {
  var loader = document.getElementById('page-loader');
  if (!loader) return;

  var minDuration = parseFloat(loader.dataset.minDuration || '0') * 1000;
  var startTime = Date.now();
  var hidden = false;

  function removeLoader() {
    loader.remove();
  }

  function hideLoader() {
    if (hidden) return;
    hidden = true;
    loader.classList.add('page-loader--hidden');
    loader.addEventListener('transitionend', removeLoader, { once: true });
    // Fallback in case the transition doesn't fire (e.g. reduced motion, no CSS transition support)
    setTimeout(removeLoader, 800);
  }

  function onReady() {
    var remaining = Math.max(minDuration - (Date.now() - startTime), 0);
    setTimeout(hideLoader, remaining);
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    window.addEventListener('load', onReady, { once: true });
  }
})();
